<template>
  <el-dialog :title="$t('common.del')+$t('common.tips')" class="deleteFile"
             :visible.sync="deleteVisible" :before-close="handleClose" :show-close="false">
    <div class="line-box"></div>
    <div class="content-words">{{content}}</div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('common.cancel')}}</el-button>
      <!-- delType = 1 文件项目列表单个删除 -->
      <el-button type="primary" class="confirm-btn" @click="handleConfirm" v-if="delType === 1">
        {{$t('common.ok')}}
      </el-button>
      <!-- delType = 2 文件项目列表多个删除 -->
      <el-button type="primary" class="confirm-btn" @click="handleDelFileList"
                 v-else-if="delType === 2">{{$t('common.ok')}}</el-button>
      <el-button type="primary" class="confirm-btn" @click="handleOk" v-else>{{$t('common.ok')}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'deleteFile',
  props: ['deleteVisible', 'content', 'delType'],
  methods: {
    handleClose() {
      this.$emit('deleteCancel');
    },
    handleConfirm() {
      this.$emit('deleteConfirm');
    },
    handleDelFileList() {
      this.$emit('delFileList');
    },
    handleOk() {
      this.$emit('handleOk');
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>